import "./App.css";
import RouteConfig from "./routes";

const App = () => {
  return <RouteConfig />;
};

export default App;
